export class GoogleApiHelper {
  static drawCirclePath(
    lat: number,
    lng: number,
    radius: number,
    detail: number = 8,
  ) {
    let R = 6371

    let pi = Math.PI

    lat = (lat * pi) / 180
    lng = (lng * pi) / 180
    let d = radius / R

    let points: [number, number][] = []
    let i

    for (i = 0; i <= 360; i += detail) {
      let brng = (i * pi) / 180

      let plat = Math.asin(
        Math.sin(lat) * Math.cos(d) +
          Math.cos(lat) * Math.sin(d) * Math.cos(brng),
      )
      let plng =
        ((lng +
          Math.atan2(
            Math.sin(brng) * Math.sin(d) * Math.cos(lat),
            Math.cos(d) - Math.sin(lat) * Math.sin(plat),
          )) *
          180) /
        pi
      plat = (plat * 180) / pi

      let currentPoints: [number, number] = [plat, plng]
      points.push(currentPoints)
    }

    return GoogleApiHelper.createEncodings(points)
  }

  private static createEncodings(coords: [number, number][]) {
    let i

    let plat = 0
    let plng = 0

    var encoded_points = ''

    for (i = 0; i < coords.length; ++i) {
      var lat = coords[i][0]
      var lng = coords[i][1]

      encoded_points += GoogleApiHelper.encodePoint(plat, plng, lat, lng)

      plat = lat
      plng = lng
    }

    return encoded_points
  }

  private static encodePoint(
    plat: number,
    plng: number,
    lat: number,
    lng: number,
  ) {
    const late5 = Math.round(lat * 1e5)
    const plate5 = Math.round(plat * 1e5)
    const lnge5 = Math.round(lng * 1e5)
    const plnge5 = Math.round(plng * 1e5)
    const dlng = lnge5 - plnge5
    const dlat = late5 - plate5
    return (
      GoogleApiHelper.encodeSignedNumber(dlat) +
      GoogleApiHelper.encodeSignedNumber(dlng)
    )
  }

  private static encodeSignedNumber(num: number) {
    let sgn_num = num << 1
    if (num < 0) sgn_num = ~sgn_num
    return GoogleApiHelper.encodeNumber(sgn_num)
  }

  private static encodeNumber(num: number) {
    let encodeString = ''
    while (num >= 0x20) {
      encodeString += String.fromCharCode((0x20 | (num & 0x1f)) + 63)
      num >>= 5
    }
    encodeString += String.fromCharCode(num + 63)
    return encodeString
  }
}
